/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DinamicoAliases {
  FETCH_0 = 'fetch-0',
  FETCH_1 = 'fetch-1',
  HPMS_DYNAMIC_SCREEN = 'hpms-dynamic-screen',
  LAYOUT_DINAMICO = 'layout-dinamico',
  MAPPER_0 = 'mapper-0',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  TEXT_0 = 'text-0',
}
export { DinamicoAliases };
